<template>
  <qrcode-reader @decode="onDecode" :paused="internalPaused"></qrcode-reader>
</template>

<script>
import { QrcodeReader } from 'vue-qrcode-reader'

export default {
  components: { QrcodeReader },
  props: ['paused'],
  created() {
    this.internalPaused = this.paused
  },
  data() {
    return {
      lastExecution: new Date(),
      internalPaused: false
    }
  },
  computed: {
    eventId() {
      return this.$store.getters.selectedEvent.id
    }
  },
  methods: {
    onDecode(decodedString) {
      this.internalPaused = true
      setTimeout(() => {
        this.internalPaused = false
      }, 100)
      let currentTime = new Date()
      if (currentTime.getTime() > this.lastExecution.getTime() + 1500) {
        this.lastExecution = new Date()
        if (decodedString.includes('wixevents.com')) {
          const ticketRegex = decodedString.match(/[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]*/gm)
          decodedString = ticketRegex[0]
        }
        // if (decodedString.length >= 8 && decodedString.length <= 20) {
        this.$store.dispatch('readTicket', { ticket: decodedString, eventId: this.eventId })
        // } else {
        //   this.$store.dispatch('setSnackbarColor', 'error')
        //   this.$store.dispatch('setSnackbarMessage', 'Ingresso inválido')
        //   this.$store.dispatch('setSnackbarOpen', true)
        // }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/validation/QRCodeValidation.vue